import { render } from "./Testimonials.vue?vue&type=template&id=2d8837ed"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=2d8837ed&lang=css"

import exportComponent from "/home/runner/work/meedly-vueportfolio/meedly-vueportfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__